module.exports = __webpack_public_path__ + "img/x_gray.87cc0501.svg";